import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { GroupId } from 'balus-common';
import { AIUsageModal } from '@user/AIUsageModal';
import { useIsAIAssistantEnabled } from '@user/pages/ViewModelPage/AIAssistant/useIsAIAssistantEnabled';
import { MenuButton } from './MenuButton';

type Props = {
  groupId: GroupId;
};

/**
 * AI利用量メニュー。AIアシスタントを利用できるユーザーにだけ表示する。
 * groupId が確定してからでないと購読パスを組めないため、呼び出し側で空文字を除いてからマウントする。
 */
export const AIUsageMenuItem: React.FC<Props> = ({ groupId }: Props) => {
  const { t } = useTranslation();
  const { enabled } = useIsAIAssistantEnabled(groupId);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  if (!enabled) return null;

  return (
    <>
      <MenuButton onClick={handleOpen}>{t('framework.topNav.aiUsage')}</MenuButton>
      <AIUsageModal isOpen={isOpen} onClose={handleClose} groupId={groupId} />
    </>
  );
};
